import React from "react";
import ContactForm from "../components/forms/ContactForm";
import "./Contact.css";
import useDocumentTitle from "../hooks/useDocumentTitle";
import { MdLocationOn, MdPhone, MdEmail, MdAccessTime } from "react-icons/md";

const Contact = () => {
  useDocumentTitle("Contact Us");

  return (
    <main className="contact-page">
      <div className="container">
        <div className="contact-grid">
          <section className="contact-info">
            <h1>Get In Touch</h1>

            <p className="contact-intro">
              Have a project in mind? We'd love to hear from you. Fill out the
              form and we'll get back to you as soon as we can.
            </p>

            <div className="info-items">
              <div className="info-item">
                <div className="info-icon-wrapper">
                  <MdLocationOn className="info-icon" />
                </div>

                <div className="info-content">
                  <h2>Visit Us</h2>
                  <p>New Baneshwor, Kathmandu, Nepal</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon-wrapper">
                  <MdPhone className="info-icon" />
                </div>

                <div className="info-content">
                  <h2>Call Us</h2>
                  <a href="tel:+97711234567">+977-1-1234567</a>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon-wrapper">
                  <MdEmail className="info-icon" />
                </div>

                <div className="info-content">
                  <h2>Email Us</h2>
                  <a href="mailto:contact@sampannasanchar.com.np">
                    contact@sampannasanchar.com.np
                  </a>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon-wrapper">
                  <MdAccessTime className="info-icon" />
                </div>

                <div className="info-content">
                  <h2>Working Hours</h2>
                  <p>Sunday - Friday: 10:00 AM - 5:00 PM</p>
                  <p>Saturday: Closed</p>
                </div>
              </div>
            </div>

            {/* Uncomment when the correct Google Maps embed URL is available */}
            {/*
            <div className="map-container">
              <iframe
                title="Sampanna Sanchar office location"
                src="YOUR_GOOGLE_MAPS_EMBED_URL"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            */}
          </section>

          <section className="contact-form-container">
            <ContactForm />
          </section>
        </div>
      </div>
    </main>
  );
};

export default Contact;
